export function getGroupPlan(groupSize, visits) {
  return PLAN_DATA.people[+groupSize].visits[+visits];
}

export function getIndividualPlan(visits) {
  return getGroupPlan(1, visits);
}

export const PLAN_DATA = {
  people: {
    // Individual
    1: {
      visits: {
        1: {
          '2d': {
            price: '9.50',
            url: {
              gift: 'payment/0f50133e-656e-4219-ba49-dc3a71a057fa/gift/',
              nonGift: 'payment/f78a7186-726d-4fd4-bc10-b64f75710e5f'
            }
          },
          premier: {
            price: '11.95',
            url: {
              gift: 'payment/551311e3-0e7e-40ab-9801-4365360c5e09/gift/',
              nonGift: 'payment/ab6203cc-002b-42ef-8ed7-acedc0e7c592'
            }
          }
        },
        2: {
          '2d': {
            price: '11.95',
            url: {
              gift: 'payment/5bd8b913-2489-4884-b37e-61392f9980e9/gift',
              nonGift: 'payment/5bd8b913-2489-4884-b37e-61392f9980e9/'
            }
          },
          premier: {
            price: '14.95',
            url: {
              gift: 'payment/474e8c9f-74ba-4d49-9b5d-1d520edd8390/gift',
              nonGift: 'payment/474e8c9f-74ba-4d49-9b5d-1d520edd8390/'
            }
          }
        },
        3: {
          '2d': {
            price: '16.95',
            url: {
              gift: 'payment/943735e1-2c76-49c7-9878-798612982be2/gift',
              nonGift: 'individual2D.com'
            }
          },
          premier: {
            price: '19.95',
            url: {
              gift: 'payment/3289f924-9700-4ef0-9d81-d3399c9e7d10/gift',
              nonGift: 'individualpremier.com'
            }
          }
        },
        5: {
          '2d': {
            price: '26.95',
            url: {
              gift: 'payment/f9a204c2-e049-4327-ab25-d4a523432a22/gift/',
              nonGift: 'payment/168645c9-580e-4811-bf51-b9783ee78859'
            }
          },
          premier: {
            price: '32.95',
            url: {
              gift: 'payment/b53349ee-2ccf-4959-ba89-ae72553d621f/gift/',
              nonGift: 'payment/63e1d997-1d9a-4c4e-8372-b605ee8edfbc'
            }
          }
        }
      }
    },

    // Group of 2
    2: {
      visits: {
        1: {
          '2d': {
            price: '18.95',
            url: {
              gift: 'payment/17b4b95e-ccae-4feb-b799-5f119ea430b3/gift/',
              nonGift: 'payment/27d30457-77ca-4fda-b35d-7e08218fa0d5'
            }
          },
          premier: {
            price: '22.95',
            url: {
              gift: 'payment/5e465f09-babf-4b4a-8226-407d65410436/gift/',
              nonGift: 'payment/8af2bd03-22f3-41ad-a534-9fd8636045ed'
            }
          }
        },
        2: {
          '2d': {
            price: '23.95',
            url: {
              gift: 'payment/1e02f6fb-5206-4d82-8bef-ac5463b8ed49/gift/',
              nonGift: 'payment/739c635a-c106-456c-befa-0f06021affbc'
            }
          },
          premier: {
            price: '30.95',
            url: {
              gift: 'payment/bed5fc3b-8268-42dd-8f59-a6e5e2d6ba5a/gift/',
              nonGift: 'payment/851bec47-ff46-45cd-9380-34335e152b27'
            }
          }
        },
        3: {
          '2d': {
            price: '32.95',
            url: {
              gift: 'payment/5f555a99-a8b0-4dd9-956c-70f0310f19c3/gift',
              nonGift: 'group22D.com'
            }
          },
          premier: {
            price: '38.95',
            url: {
              gift: 'payment/0b07ebc3-4d47-4eb5-b861-56962f397419/gift',
              nonGift: 'group2premier.com'
            }
          }
        },
        5: {
          '2d': {
            price: '51.95',
            url: {
              gift: 'payment/0c68c75b-7edb-47d6-aebe-111bcfa26504/gift/',
              nonGift: 'payment/5566bcbd-088a-46d3-8522-6f9faa974878'
            }
          },
          premier: {
            price: '63.95',
            url: {
              gift: 'payment/72954bc2-819e-49ac-8e27-54584785fda8/gift/',
              nonGift: 'payment/cbbf68a9-8bee-48b3-bdc8-172bc66fe8c6'
            }
          }
        }
      }
    },

    // Group of 3
    3: {
      visits: {
        1: {
          '2d': {
            price: '27.95',
            url: {
              gift: 'payment/8fa8d9d5-cffb-4cfb-8d4c-7bee635c8431/gift/',
              nonGift: 'payment/afc7539f-1e24-4248-bed0-2cd4fbcfff10'
            }
          },
          premier: {
            price: '33.95',
            url: {
              gift: 'payment/1dfb9d92-2f10-4cf8-a8de-496dbfc341ed/gift/',
              nonGift: 'payment/2b93d8ac-8177-454b-9eaa-e9a2afc08369'
            }
          }
        },
        2: {
          '2d': {
            price: '35.95',
            url: {
              gift: 'payment/e8aaa1c2-1ec5-43ad-8a18-a0419b110cdc/gift/',
              nonGift: 'payment/f1caf4b4-6202-4042-8951-6de726cbeaf6'
            }
          },
          premier: {
            price: '45.95',
            url: {
              gift: 'payment/11ddfe9b-3c1f-45e4-899e-0d96db836626/gift/',
              nonGift: 'payment/64d83b81-54aa-46d0-bb3a-d4b1a2ace45b'
            }
          }
        },
        3: {
          '2d': {
            price: '47.95',
            url: {
              gift: 'payment/051dd320-ec2d-45b7-9bba-7747231e7e51/gift',
              nonGift: 'group32D.com'
            }
          },
          premier: {
            price: '56.95',
            url: {
              gift: 'payment/d3d05f10-8088-4d79-987b-1847b9d7dcce/gift',
              nonGift: 'group3premier.com'
            }
          }
        },
        5: {
          '2d': {
            price: '75.95',
            url: {
              gift: 'payment/bba19f0f-75ee-4235-97fc-521fa46366e4/gift/',
              nonGift: 'payment/cd87ef32-7fd7-4fd1-aa65-0d63a6cef141'
            }
          },
          premier: {
            price: '93.95',
            url: {
              gift: 'payment/e683b0cc-a290-4e7f-9964-10599385b683/gift/',
              nonGift: 'payment/b1a8784c-c6cf-4c72-85d2-28ca2cdb65bb'
            }
          }
        }
      }
    },

    // Group of 4
    4: {
      visits: {
        1: {
          '2d': {
            price: '37.95',
            url: {
              gift: 'payment/dc1915c6-1687-43d0-9032-ee9cc2856716/gift/',
              nonGift: 'payment/3dddec23-8e5a-4c61-b210-519a02508dfa'
            }
          },
          premier: {
            price: '44.95',
            url: {
              gift: 'payment/9d4141af-b600-4353-ac9e-e8d9a8908639/gift/',
              nonGift: 'payment/b4aa3975-2779-4ebe-a032-df6a8d100870'
            }
          }
        },
        2: {
          '2d': {
            price: '47.95',
            url: {
              gift: 'payment/891a6b3f-9fb9-42ea-9fd0-8a6665991ed8/gift/',
              nonGift: 'payment/6d72c5fb-07a7-404d-9409-d6e8a3fbe75e'
            }
          },
          premier: {
            price: '60.95',
            url: {
              gift: 'payment/c2bc1733-54c3-412c-b956-6e50a51dc928/gift/',
              nonGift: 'payment/bb9a9e0a-5380-4aa1-be64-24232d12f95c'
            }
          }
        },
        3: {
          '2d': {
            price: '62.95',
            url: {
              gift: 'payment/4d4d13a9-3d64-497d-8294-bdb1c7099981/gift',
              nonGift: 'group42D.com'
            }
          },
          premier: {
            price: '73.95',
            url: {
              gift: 'payment/026c7dd1-9e5b-4687-9e38-052b760462eb/gift',
              nonGift: 'group4premier.com'
            }
          }
        },
        5: {
          '2d': {
            price: '97.95',
            url: {
              gift: 'payment/87968644-e1d3-40e4-a844-224e7ebcc7ce/gift/',
              nonGift: 'payment/edb6579a-48a7-4938-8af4-56d477858f1c'
            }
          },
          premier: {
            price: '123.95',
            url: {
              gift: 'payment/302c18c0-9132-4f56-bdfe-5ca2f125aa35/gift/',
              nonGift: 'payment/0b69226d-d5c0-46e5-8466-37dc58131d80'
            }
          }
        }
      }

    },

    // Group of 5
    5: {
      visits: {
        1: {
          '2d': {
            price: '46.95',
            url: {
              gift: 'payment/4582bb9a-9488-4591-8399-ad62979fae8c/gift/',
              nonGift: 'payment/f24003b3-960c-4e03-92a4-03c2902df29d'
            }
          },
          premier: {
            price: '55.95',
            url: {
              gift: 'payment/5cdb3707-b6a5-49fd-ab35-2a6537ec6611/gift/',
              nonGift: 'payment/715072b3-ff6b-4853-b083-d36ccdc6382c'
            }
          }
        },
        2: {
          '2d': {
            price: '58.95',
            url: {
              gift: 'payment/5715142e-5b79-4289-bae0-bb76481aa6a3/gift/',
              nonGift: 'payment/e25ba651-3c24-482a-97de-29792a2551d6'
            }
          },
          premier: {
            price: '75.95',
            url: {
              gift: 'payment/76b9a261-f0e6-46f9-9feb-3c4012bc971c/gift/',
              nonGift: 'payment/4bacba64-683d-43dd-823e-3476319f4a14'
            }
          }
        },
        3: {
          '2d': {
            price: '76.95',
            url: {
              gift: 'payment/42b32c43-5a7f-4690-9f5f-88b993bf0fc2/gift',
              nonGift: 'group52D.com'
            }
          },
          premier: {
            price: '89.95',
            url: {
              gift: 'payment/1cd90985-4170-4080-a1cc-218636d8fe20/gift',
              nonGift: 'group5premier.com'
            }
          }
        },
        5: {
          '2d': {
            price: '119.95',
            url: {
              gift: 'payment/58920c5d-8024-4f26-b384-1aa80696d3a4/gift/',
              nonGift: 'payment/3e72ad9c-977d-450d-81f9-2a0a56b54f28'
            }
          },
          premier: {
            price: '153.95',
            url: {
              gift: 'payment/0f7fc60c-8745-441b-a1ba-37ce22a5aea8/gift/',
              nonGift: 'payment/ee458bc5-a69d-4655-b24d-6350d4c9d0c6'
            }
          }
        }
      }

    },

    // Group of 6
    6: {
      visits: {
        1: {
          '2d': {
            price: '55.95',
            url: {
              gift: 'payment/676e3665-4f8a-45f5-ba9e-cedc16f3f7dd/gift/',
              nonGift: 'payment/8d457bac-a0d0-4d80-8166-5be159cc4861'
            }
          },
          premier: {
            price: '66.95',
            url: {
              gift: 'payment/c803c5e1-20f0-4540-ad88-c0859ce8ddf2/gift/',
              nonGift: 'payment/ad33c799-b4ed-43ee-b0c4-19c454fce61b'
            }
          }
        },
        2: {
          '2d': {
            price: '70.95',
            url: {
              gift: 'payment/85ea6b03-ae10-4dee-8631-44600841f467/gift/',
              nonGift: 'payment/2dbdd288-4318-4eae-8012-5499b6024d8d'
            }
          },
          premier: {
            price: '90.95',
            url: {
              gift: 'payment/a3f17ade-ac32-4db9-b712-b521b6a765f8/gift/',
              nonGift: 'payment/9e32a9a6-553e-48f3-9a9f-201be1de3ac5'
            }
          }
        },
        3: {
          '2d': {
            price: '89.95',
            url: {
              gift: 'payment/0f6fd09b-424d-46f9-9f62-231210a483ee/gift',
              nonGift: 'group62D.com'
            }
          },
          premier: {
            price: '105.95',
            url: {
              gift: 'payment/0b6cce53-f106-462f-94f5-eba28d06189a/gift',
              nonGift: 'group6premier.com'
            }
          }
        },
        5: {
          '2d': {
            price: '140.95',
            url: {
              gift: 'payment/940c8d7e-ceef-489a-804d-2865e6a6bac8/gift/',
              nonGift: 'payment/3bc38e39-6833-4559-a634-ff45dbe96b96'
            }
          },
          premier: {
            price: '182.95',
            url: {
              gift: 'payment/86d14077-ae45-4ac0-ac15-002c62e16612/gift/',
              nonGift: 'payment/1e0825e2-d6c6-4050-b85b-ade37206d5c2'
            }
          }
        }
      }
    }
  }
}